module.exports = __webpack_public_path__ + "static/bluewhale3-c883ca9b68c977238d313ae37983df90.png";